// extracted by mini-css-extract-plugin
module.exports = {"ul":"Tabs_ul__3AJCJ","activeTab":"Tabs_activeTab__2OC5w","li":"Tabs_li__2pNDA"};